export class VultrSnapshot {
    public id: string;
    public dateCreated: string;
    public description: string;
    public status: string;


    constructor(id: string, dateCreated: string, description: string, status: string) {
        this.id = id;
        this.dateCreated = dateCreated;
        this.description = description;
        this.status = status;
    }
}